import { render } from "./ImageAnnotorious.vue?vue&type=template&id=67a43cfe&scoped=true"
import script from "./ImageAnnotorious.vue?vue&type=script&lang=js"
export * from "./ImageAnnotorious.vue?vue&type=script&lang=js"

import "./ImageAnnotorious.vue?vue&type=style&index=0&id=67a43cfe&scoped=true&lang=css"

import exportComponent from "/builds/weborigo-projects/vivien-vance/core-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67a43cfe"]])

export default __exports__